import React, { useState } from 'react';
import { useFilesInput } from 'hooks/useFilesInput';
import { GeneralModal } from 'ui/GeneralModal';
import FluidButton from 'ui/FluidButton';

interface IHeroImageUploadModalProps {
  isOpen: boolean;
  onClose: () => void;
  onUpload: (file: File, displayName: string) => Promise<void>;
}

export const HeroImageUploadModal = ({
  isOpen,
  onClose,
  onUpload,
}: IHeroImageUploadModalProps) => {
  const [isUploading, setIsUploading] = useState<boolean>(false);
  const filesInput = useFilesInput({
    accept: 'image/*',
  });

  const handleModalClose = () => {
    filesInput.reset();
    setIsUploading(false);
    onClose();
  };

  const handleUploadConfirm = async () => {
    const file = filesInput.files[0];
    if (!file) {
      return;
    }

    setIsUploading(true);
    try {
      await onUpload(file, 'Hero image');
      handleModalClose();
    } catch (error) {
      // Error handling is done in the parent component
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <GeneralModal
      isOpen={isOpen}
      onClose={handleModalClose}
      modalWindowClassName="p-4 text-black font-pt-sans w-[587px]"
      isCloseButtonVisible={false}
    >
      <h2 className="m-0 font-noe-display text-21px text-black font-normal mb-25px">Change Hero Photo</h2>
      
      <span className="block">File</span>
      {filesInput.renderInput()}

      <div className="flex flex-row gap-2 mt-25px">
        <FluidButton
          disabled={filesInput.files.length === 0 || isUploading}
          type="primary"
          className="mt-10px"
          onClick={handleUploadConfirm}
        >
          {isUploading ? 'Uploading...' : 'Upload & Set Hero Image'}
        </FluidButton>
        <FluidButton type="secondary" className="mt-10px" onClick={handleModalClose}>
          Cancel
        </FluidButton>
      </div>
    </GeneralModal>
  );
};